import { createFileRoute, useNavigate } from "@tanstack/react-router";
import type { JSX } from "react";

import { PromotionBuilderPage, type PerformanceTab } from "@/features/promotion";

import { lastListSearch } from "./-promotion-list-search";

interface PromotionDetailSearch {
  tab?: PerformanceTab;
}

function PromotionBuilderRoute(): JSX.Element {
  const navigate = useNavigate();
  const { promotionId } = Route.useParams();
  const { tab } = Route.useSearch();
  return (
    <PromotionBuilderPage
      promotionId={promotionId}
      {...(tab ? { tab } : {})}
      // Push (not replace): a tab switch is a history entry so Back returns to the other tab.
      onTabChange={(next) =>
        void navigate({
          to: "/promotion/$promotionId",
          params: { promotionId },
          search: { tab: next },
        })
      }
      onBack={() => void navigate({ to: "/promotion", search: lastListSearch() })}
    />
  );
}

// `promotion_` opts out of nesting under `/promotion` (the list) so this builder
// renders standalone at `/promotion/$promotionId` instead of inside an Outlet.
export const Route = createFileRoute("/_authenticated/promotion_/$promotionId")({
  // Spec §5.1: the active tab lives in `?tab=` (shareable, Back works).
  validateSearch: (raw: Record<string, unknown>): PromotionDetailSearch =>
    raw.tab === "setup" || raw.tab === "performance" ? { tab: raw.tab } : {},
  component: PromotionBuilderRoute,
});
